// Shared types for the built-in landing-page starters (./*.ts).
import type { PageContent, PageTheme } from '../model/pages';

/** A starter's form field: a standard key (full_name, email, phone, company,
 *  website), or an object with that key and Orbit's step/required flags. The
 *  CRM form a template creates (starterForm) asks for these on its contact
 *  screen; the gallery's FormMock draws the same screen from them. */
export type StarterFormField = string | { key: string; step?: number; required?: boolean };

/** Gallery grouping for the New page picker. */
export type StarterCategory = 'course' | 'sales' | 'leads' | 'event' | 'calls' | 'software';

export const STARTER_CATEGORIES: readonly { key: StarterCategory; label: string }[] = [
  { key: 'course', label: 'Courses' },
  { key: 'sales', label: 'Sales pages' },
  { key: 'leads', label: 'Lead magnets' },
  { key: 'event', label: 'Webinars' },
  { key: 'calls', label: 'Book a call' },
  { key: 'software', label: 'Software' },
];

export interface PageStarter {
  key: string;
  name: string;
  description: string;
  /** Which gallery tab it shows under (absent = only under All). */
  category?: StarterCategory;
  content: PageContent;
  theme: PageTheme;
  form?: StarterFormField[];
  /** The form's first screen title (the CRM contact question). */
  formTitle?: string;
  /** The line under that title (the contact question's help text). */
  formDescription?: string;
  /** Orbit's submit label. CRM forms label their own buttons, so it is kept as
   *  reference copy only. */
  formButton?: string;
}
